import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  /account/wishlist

  <span style="color:#85c1dc;">**FI:**</span>
  /account/wishlist

  <span style="color:#85c1dc;">**RU:**</span>
  /account/wishlist
*/
/* @__NO_SIDE_EFFECTS__ */
const m1010 = msg(
  mf`/account/wishlist`,
  mf`/account/wishlist`,
  mf`/account/wishlist`,
)

export { m1010 as 'w.basket.empty.first.link' }